import {Component} from '@angular/core';

@Component({
  selector: 'app-assessment-finished',
  templateUrl: './assessment-finished.component.html',
  styleUrls: ['./assessment-finished.component.scss'],
})
export class AssessmentFinishedComponent {}
